import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Box, Container, IconButton, Paper, Stack } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearScrollReference,
  selectScrollReferenceId,
  selectSelectedSubControls,
  setScrollPosition,
} from '../../redux/reducers/assessmentReducer';
import debounce from '../../utils/debounce';
import EvaluationControl from './EvaluationControl';
import EvaluationList from './EvaluationList';

function AssessmentEvaluation() {
  const dispatch = useDispatch();
  const [showTitles, setShowtitles] = useState(true);
  const controlList = useSelector(selectSelectedSubControls);
  const scrollReference = useRef(null);
  const scrollReferenceId = useSelector(selectScrollReferenceId);

  useEffect(() => {
    if (scrollReferenceId !== null) {
      scrollReference?.current?.scrollIntoView();
      dispatch(clearScrollReference());
      window.scrollTo({ top: 0 });
    }
  }, [scrollReferenceId]);

  const toggleTitles = () => {
    setShowtitles(!showTitles);
  };

  const handleScroll = (e) => {
    dispatch(setScrollPosition(e.target.scrollTop));
  };
  const debouncedHandleScroll = debounce(handleScroll, 100);

  return (
    <Container variant="assessmentDataViewFixed" maxWidth={false} disableGutters>
      <Box
        sx={{
          p: '2px',
          mr: '16px',
          width: showTitles ? 400 : 44,
          overflowY: 'auto',
          overflowX: 'hidden',
        }}
      >
        <Paper variant="elevation" sx={{ minHeight: '100%' }} onClick={!showTitles ? () => toggleTitles() : null}>
          <Stack direction="row" justifyContent={showTitles ? 'flex-end' : 'center'}>
            <IconButton id='toggle-control-titles' onClick={showTitles ? () => toggleTitles() : null}>
              {showTitles ? <KeyboardDoubleArrowLeftIcon /> : <KeyboardDoubleArrowRightIcon />}
            </IconButton>
          </Stack>
          {showTitles && <EvaluationList />}
        </Paper>
      </Box>
      <Box
        onScroll={debouncedHandleScroll}
        sx={{
          p: '2px',
          flexGrow: 1,
          overflowY: 'auto',
          overflowX: 'hidden',
          maxWidth: showTitles ? 800 : 1140,
        }}
      >
        <Stack spacing={2} sx={{ width: '100%', marginBottom: '24px' }}>
          {controlList.map((control) => (
            <EvaluationControl control={control} key={control.id} scrollReference={scrollReference} />
          ))}
        </Stack>
      </Box>
    </Container>
  );
}
export default AssessmentEvaluation;
